import React from "react";
import { Navigate } from "react-router-dom";
import { isInternationalTheme } from "config/ConfigUtils";
import { consumePostAuthPath } from "features/start/start-flags";

const DefaultRedirect = () => {
  const fallback = isInternationalTheme() ? "/dashboard" : "/users";
  return <Navigate to={consumePostAuthPath(fallback)} replace />;
};

export default DefaultRedirect;
